import { parseFrontmatter, renderMarkdown, formatContentDate, parseImageFields, type ContentImage } from "./content";

export interface BlogPost extends ContentImage {
  slug: string;
  title: string;
  description: string;
  date: string; // ISO yyyy-mm-dd
  html: string;
}

// Markdown files are bundled at build time — there's no CMS, no runtime
// fetch, and no database; the content lives in this repo like any other
// source file. Adding a post means adding a .md file here.
const files = import.meta.glob("../content/blog/*.md", {
  eager: true,
  query: "?raw",
  import: "default",
}) as Record<string, string>;

const posts: BlogPost[] = Object.entries(files)
  .map(([path, raw]) => {
    const slug = path.split("/").pop()!.replace(/\.md$/, "");
    const { meta, body } = parseFrontmatter(raw);
    return {
      slug,
      title: meta.title ?? slug,
      description: meta.description ?? "",
      date: meta.date ?? "",
      html: renderMarkdown(body),
      ...parseImageFields(meta),
    };
  })
  .sort((a, b) => (a.date < b.date ? 1 : -1));

export function getAllPosts(): BlogPost[] {
  return posts;
}

export function getPostBySlug(slug: string): BlogPost | undefined {
  return posts.find((p) => p.slug === slug);
}

export const formatBlogDate = formatContentDate;
